<template>
  <div id="LandfillManagement" class="q-px-md q-py-xs">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :id="id"
      :page="page"
      :pageDetail="pageDetail"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import LandfillManagementPage from './../landfill-management/LandfillManagementPage'

const { CrudLayoutSearch, CrudLayout } = JtCrud

@Component({
  name: 'LandfillManagement',
  components: {
    CrudLayout,
    LandfillManagementPage
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class LandfillManagement extends Vue {
  async mounted () {
    try {
      if (this.$refs.crudLayout.state.containers[this.id]) return
      const forms2 = await repository.resolve(this.interface, {})
      const datatable = await repository.resolveDatatable(this.interface)
      this.$refs.crudLayout.addPage({
        name: this.name,
        label: this.$gettext('LANDFILL_MANAGEMENT'),
        params: forms2[0].dadosForm,
        datatable: datatable,
        component: this.$refs.crudLayout._pageTable,
        flClose: false,
        forms: forms2
      })
    } catch (error) {
      console.error(error)
    }
  }

  get pageDetail () {
    return LandfillManagementPage
  }

  get page () {
    return LandfillManagementPage
  }
}
export default LandfillManagement
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#LandfillManagement {
 .dataTableCrud {
     height: calc(65vh - 25px);
     box-shadow: none!important;
     padding: 0px 10px;
   }

  ::v-deep {
    .jt-crud-container {
      padding: 0%;
    }
  }

   .buttons-top-crud{
    margin-top: 5px;
    margin-bottom: -3px;
  }

.padding-crud{
     padding: 0px 10px 10px;
     margin-top: -15px;
   }

    .itemSelect{
     color: white;
     background: $secondary!important;
     border-left: 5px solid $dark!important;
     padding-left: 5%!imporant;
   }

   .item{
     background: white;
     font-weight: 500;
     padding-left: 10%;
     font-size: 1rem;
   }
 }
</style>
